module.exports = __webpack_public_path__ + "static/img/Jason-Taumalolo.a3d89dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Taumalolo.jpg
// module id = 9qtf
// module chunks = 0